module.exports = __webpack_public_path__ + "static/media/fuel-pump.326b9657.svg";